<script setup lang="ts">
import type { SightlineUserCell } from "@/backend/natsstubs/sightline/models";

import SightlineTruncatedText from "./SightlineTruncatedText.vue";

defineProps<{ cell: SightlineUserCell }>();
</script>

<template>
  <SightlineTruncatedText :text="cell.label" icon="persona/user" />
</template>
